import script from "./ModeratorLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./ModeratorLayout.vue?vue&type=script&setup=true&lang=js"

import "./ModeratorLayout.vue?vue&type=style&index=0&id=226bbae8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-226bbae8"]])

export default __exports__